<template>
  <div>
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                  {{ $t('listeMateriel.title') }}
                </h1>
                <app-breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <materiel-tlpe :collectiviteId="$route.params.id" />
  </div>
</template>

<script>

import breadcrumb from '@/components/general/breadcrumb';
import materielTlpe from '@/components/gabed/materiel/l_materielTlpe';

export default {
  components: {
    appBreadcrumb: breadcrumb,
    materielTlpe,
  },
  computed: {
    breadcrumb() {
      return [
        { title: this.$i18n.t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeMateriel.title'), route: '', isActive: true },
      ];
    },
  },
  mounted() {
    this.setInformationPage(this.$t('pagePatrimoine.emplacement.materiel.liste'));
  },
};
</script>
